import type { App, Environment } from '@hangar/shared';
import type { EnvVar } from '@/api/schemas';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { EnvVarForm } from './EnvVarForm';
import type { ScopeSelection } from './ScopePicker';

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  /** Present → edit metadata (value changes go through "New version"). */
  editing?: EnvVar;
  projectId: string;
  scope: ScopeSelection;
  apps: App[] | undefined;
  environments: Environment[];
}

/**
 * Create (key, value, visibility, type, config-time, scope) or edit metadata (description, visibility raise, type,
 * config-time). The form is `EnvVarForm`; its rules are in `envVarModel.ts` and its state in `useEnvVarForm`.
 */
export function EnvVarSheet({ open, onOpenChange, editing, projectId, scope, apps, environments }: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" data-testid="env-var-sheet" className="w-full gap-0 p-0" aria-describedby="env-var-desc">
        {open ? <EnvVarForm key={editing?.id ?? 'new'} editing={editing} projectId={projectId} scope={scope} apps={apps} environments={environments} onDone={() => onOpenChange(false)} /> : null}
      </SheetContent>
    </Sheet>
  );
}
